import React, { useEffect, useState } from 'react';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { ButtonLink } from './ui/Button';
import { company, navLinks } from '../data/site';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b transition-[background-color,border-color,box-shadow] duration-200 ease-out ${scrolled || open ? 'border-charcoal-200 bg-white/95 shadow-sm backdrop-blur' : 'border-transparent bg-white/85 backdrop-blur'}`} data-id="element-157" data-mp="36bl631excrqh">
      <div className="mx-auto flex h-[72px] max-w-container items-center justify-between gap-6 px-5 lg:px-8" data-id="element-158" data-mp="2wlvz12vlidq4">
        <a href="#home" className="flex shrink-0 items-center" aria-label={`${company.name} — home`} data-id="element-159" data-mp="2rkykr1dpi3tw">
          <img src={company.logoUrl} alt="CoPro Services logo" className="h-9 w-auto sm:h-10" data-id="element-160" data-mp="2mngbf9vs1mld" />
        </a>

        <nav aria-label="Main" className="hidden lg:block" data-id="element-161" data-mp="3fb2l8zvllngo">
          <ul className="flex items-center gap-4 xl:gap-7" data-id="element-162" data-mp="3fakf9bj4vuvk">
            {navLinks.map(link => <li key={link.href} data-id="element-163" data-mp="3ad11ecqclk45">
                <a href={link.href} className="text-sm font-semibold text-charcoal-700 transition-colors duration-150 ease-out hover:text-cobalt-700 xl:text-[15px]" data-id="element-164" data-mp="35l9dk9yktshp">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="hidden items-center gap-5 lg:flex" data-id="element-165" data-mp="3ta2945badybs">
          <a href={company.phoneHref} className="flex items-center gap-2 text-[15px] font-bold text-charcoal-900 transition-colors duration-150 ease-out hover:text-cobalt-700" data-id="element-166" data-mp="1rdl5alipvq1m">
            <PhoneIcon className="h-4 w-4 text-cobalt-700" aria-hidden="true" data-id="element-167" data-mp="1ho9vewo0ahco" />
            {company.phoneDisplay}
          </a>
          <ButtonLink href="#contact" data-id="element-168" data-mp="1mljul41767dp">Request a Quote</ButtonLink>
        </div>

        <div className="flex items-center gap-3 lg:hidden" data-id="element-169" data-mp="18mtwbl2n61nr">
          <a href={company.phoneHref} aria-label={`Call ${company.phoneDisplay}`} className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-charcoal-200 text-charcoal-800 transition-colors duration-150 ease-out hover:border-cobalt-700 hover:text-cobalt-700" data-id="element-170" data-mp="18pg2bg9vw93v">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-171" data-mp="2t2ng5sngqgoh" />
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-charcoal-200 text-charcoal-900 transition-colors duration-150 ease-out hover:border-charcoal-800" data-id="element-172" data-mp="2y204yixw9xtp">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-173" data-mp="rc6ir6r8oez8" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-174" data-mp="1544kuxmj9alw" />}
          </button>
        </div>
      </div>

      {open && <div id="mobile-nav" className="border-t border-charcoal-100 bg-white px-5 pb-6 pt-4 lg:hidden" data-id="element-175" data-mp="1085oamr1wmae">
          <nav aria-label="Mobile" data-id="element-176" data-mp="1a3pjt81pdiym">
            <ul className="flex flex-col" data-id="element-177" data-mp="1a4s8rafgtbbw">
              {navLinks.map(link => <li key={link.href} data-id="element-178" data-mp="3gvqaa394rfhi">
                  <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-charcoal-100 py-3.5 text-base font-semibold text-charcoal-800" data-id="element-179" data-mp="3gwt3ihtxdu0l">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <ButtonLink href="#contact" size="lg" className="mt-5 w-full" onClick={() => setOpen(false)} data-id="element-180" data-mp="2cy645z5rub4r">
            Request a Quote
          </ButtonLink>
        </div>}
    </header>;
}